import { render, staticRenderFns } from "./notifications_list.vue?vue&type=template&id=40c71324&scoped=true&"
import script from "./notifications_list.vue?vue&type=script&lang=js&"
export * from "./notifications_list.vue?vue&type=script&lang=js&"
import style0 from "./notifications_list.vue?vue&type=style&index=0&id=40c71324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c71324",
  null
  
)

export default component.exports